import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const AnalystServiceConfig = {
  name: "Analyst",
  annotations: []
} as ServiceConfig;